import * as Yup from 'yup';

import { maybeTransformEmptyRichTextContentToNull } from 'shared/utils';
import {
  ReporterNote,
  ReporterNotesChanges,
  ReporterNotesFormValues,
  ReporterNoteToggle,
} from './reporterNotes.types';

export const reporterNotesDefaultFormValues: ReporterNotesFormValues = {
  reporterNoteToggles: [],
  newReporterNote: '',
};

export const reporterNotesValidationSchema = {
  reporterNoteToggles: Yup.array(),
  newReporterNote: Yup.string(),
};

export const reporterNotesChangesToFormValues = (
  changes?: ReporterNotesChanges,
): ReporterNotesFormValues => ({
  reporterNoteToggles: changes?.toggles ?? [],
  newReporterNote: changes?.newNote ?? '',
});

export const isReporterNoteArchived = (
  note: ReporterNote,
  toggles: ReporterNoteToggle[],
): boolean =>
  toggles.find((toggle) => toggle.reporterNoteId === note.id)?.isArchived ??
  note.isArchived;

export const toggleReporterNoteArchived = (
  note: ReporterNote,
  toggles: ReporterNoteToggle[],
): ReporterNoteToggle[] => {
  const willBeArchived = !isReporterNoteArchived(note, toggles);
  const otherToggles = toggles.filter(
    (toggle) => toggle.reporterNoteId !== note.id,
  );

  return willBeArchived === note.isArchived
    ? otherToggles
    : [
        ...otherToggles,
        { reporterNoteId: note.id, isArchived: willBeArchived },
      ];
};

export const hasReporterNotesChanges = (
  values: ReporterNotesFormValues,
): boolean =>
  Boolean(maybeTransformEmptyRichTextContentToNull(values.newReporterNote)) ||
  values.reporterNoteToggles.length > 0;

export const buildReporterNotesPayload = (
  values: ReporterNotesFormValues,
): ReporterNotesChanges | undefined => {
  if (!hasReporterNotesChanges(values)) return undefined;

  const newNote = maybeTransformEmptyRichTextContentToNull(
    values.newReporterNote,
  );
  const toggles = values.reporterNoteToggles;

  return {
    ...(newNote && { newNote }),
    ...(toggles.length > 0 && { toggles }),
  };
};
